import { ValidationProvider, ValidationObserver, localize, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import * as rules from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("en", en);

extend("required", {
  ...required,
  message: "This field is required"
});

extend('email', {
  ...email,
  message: 'The field must be a valid email address'
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
